export default __webpack_public_path__ + "static/media/May2021.0f042768.png";